/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlAuth0RolesInput = {
    AccountAdmin: 'Control - Account Admin',
    ComplianceAuditorRole: 'Control - Compliance Auditor Role',
    ExecRisksRole: 'Control - ExecRisks Role',
    FinanceRole: 'Control - Finance Role',
    InsuranceRole: 'Control - Insurance Role',
    ItSecurity: 'Control - IT/Security',
    MspAnalystRole: 'Control - MSP Analyst role',
    Superuser: 'Control - Superuser',
    ViewerRole: 'Control - Viewer Role'
} as const;
export type ControlAuth0RolesInput = typeof ControlAuth0RolesInput[keyof typeof ControlAuth0RolesInput];


export function ControlAuth0RolesInputFromJSON(json: any): ControlAuth0RolesInput {
    return ControlAuth0RolesInputFromJSONTyped(json, false);
}

export function ControlAuth0RolesInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAuth0RolesInput {
    return json as ControlAuth0RolesInput;
}

export function ControlAuth0RolesInputToJSON(value?: ControlAuth0RolesInput | null): any {
    return value as any;
}

